class Validation {
	constructor(form) {
		this.form = form
		this.fields = form.querySelectorAll('.js-field-validation')

		this.form.addEventListener('submit', e => {
			e.preventDefault()

			this.fields.forEach(item => {
				this.setFieldError(item)
			})
		})
	}

	setFieldError(field) {
		if (field.value.length > 0) {
			field.classList.remove('field__item_error')
		} else {
			field.classList.add('field__item_error')
		}
	}
}

const forms = []
const nodeForms = document.querySelectorAll('.js-form-validation')
if (nodeForms.length) {
	nodeForms.forEach((item, key) => {
		forms[key] = new Validation(item)
	})
}

export default forms
